import { render, staticRenderFns } from "./CVTips.vue?vue&type=template&id=613445bb&"
import script from "./CVTips.vue?vue&type=script&lang=ts&"
export * from "./CVTips.vue?vue&type=script&lang=ts&"
import style0 from "./CVTips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports